<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockConfirm.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockConfirm.pageTitle'),
            href: '/admin/stock-confirm'
          },
          {
            text: $t('stockConfirm.confirm'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div
            class="ts-border ts-border-blue-300 ts-p-3 ts-rounded"
            v-if="!isAvailableShow"
          >
            <form class="form-horizontal">
              <div class="row">
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.branch') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.branch.branch_name_en"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.location') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.location.location_name_en"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.supplier') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="
                          edit_data.supplier
                            ? edit_data.supplier.vendor_name
                            : null
                        "
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.stockInDate') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none"
                        type="text"
                        :value="edit_data.stock_in_date"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.invoiceNo') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-blue-500 ts-font-extrabold"
                        type="text"
                        :value="edit_data.invoice_no"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.poNumber') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-blue-500 ts-font-extrabold"
                        type="text"
                        :value="
                          edit_data.purchase_order
                            ? edit_data.purchase_order.po_number
                            : null
                        "
                        readonly
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.stockInNumber') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-text-red-600 ts-font-extrabold"
                        type="text"
                        :value="edit_data.stock_in_number"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="row">
                    <label class="col-md-4 col-form-label"
                      >{{ $t('stockConfirm.createdBy') }} :</label
                    >
                    <div class="col-md-8">
                      <input
                        class="ts-px-1 ts-py-2 ts-outline-none ts-font-extrabold"
                        type="text"
                        :value="edit_data.user.name"
                        readonly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div
            class="ts-border ts-border-gray-300 ts-p-3 ts-rounded ts-mt-3 max-h"
            v-if="!isAvailableShow"
          >
            <SearchBox v-model="model" :placeholder="$t('search')" />
            <br>
            <table class="ts-w-full ts-overflow-scroll ts-mt-3">
              <thead>
                <tr>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-16 ts-text-center"
                  >
                    {{ $t('stockConfirm.no') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40"
                  >
                    {{ $t('stockConfirm.barcode') }}
                  </th>
                  <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">
                    {{ $t('stockConfirm.productName') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40 ts-text-center"
                  >
                    {{ $t('stockConfirm.uom') }}
                  </th>
                  <th
                    class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-40 ts-text-center"
                  >
                    {{ $t('stockConfirm.quantity') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in resources" :key="index" class="ts-border-b ts-border-gray-300">
                  <td class="ts-px-2 ts-py-1 ts-text-center">
                    {{ index + 1 }}
                  </td>
                  <td class="ts-px-2 ts-py-1">{{ item.barcode }}</td>
                  <td class="ts-px-2 ts-py-1">{{ item.product_name_en }}</td>
                  <td class="ts-px-2 ts-py-1 ts-text-center">
                    {{ item.uom_name_en }}
                  </td>
                  <td class="ts-px-2 ts-py-1 ts-text-center ts-text-red-600">
                    <strong>{{ item.quantity }}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <br>
          <div class="row">
            <div class="col-md-4">
              <label>{{ $t('stockConfirm.remark') }}</label>
              <textarea 
                v-model.trim="dataSend.remarks"
                rows="3" class="form-control"
              ></textarea>
            </div>
          </div>
          <div class="ts-flex ts-space-x-3 ts-mt-3 ts-justify-end">
            <ts-button
              @click.prevent="() => $router.push({ name: 'stock-confirm' })"
              >{{ $t('cancel') }}</ts-button
            >
            <ts-button
              color="primary"
              :waiting="waiting"
              @click.prevent="onConfirm"
              :disabled="isAlreadyConfirm"
              >{{ $t('stockConfirm.confirm') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import SearchBox from './components/search-box.vue'
export default {
  name: 'viewStockInConfirm',
  components: {
    SearchBox
  },
  data () {
    return {
      loading: false,
      waiting: false,
      dataSend: {
        remarks: null,
        stock_in_id: null
      },
      model: {
        search_value: ''
      }
    }
  },
  computed: {
    ...mapState('stock/stockInConfirm', ['edit_data']),
    resources: vm => {
      return vm.edit_data.stock_in_details.filter(
        p =>
          p.barcode
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase()) ||
          p.product_name_en
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase()) ||
          p.uom_name_en
            .toLowerCase()
            .includes(vm.model.search_value.toLowerCase())
      )
    },
    isAvailableShow () {
      return _.isEmpty(this.edit_data)
    },
    isAlreadyConfirm () {
      if (!_.isEmpty(this.edit_data)) {
        return this.edit_data.is_confirm_stock
      }
      return false
    }
  },
  methods: {
    ...mapActions('stock/stockInConfirm', ['find']),
    async fetchData(){
      this.loading = true
      await this.find(this.$route.params.id)
      this.dataSend.stock_in_id = this.edit_data.stock_in_id
      this.dataSend.remarks = this.edit_data.remarks
      this.loading = false
    },
    onConfirm (record) {
      this.waiting = true
      this.$store
        .dispatch('stock/stockInConfirm/store', this.dataSend)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'stock-confirm' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('stock/stockInConfirm/SET_EDIT_DATA', [])
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
<style scoped>
/* .max-h {
	min-height: 50vh;
  max-height: 60vh;
} */
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  border-spacing: 0;
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
</style>
